export interface PageDemandSideLike {
  source?: string;
  confidence?: string;
  detail?: string;
}

export function formatPageDemandSourceConfidence(side: PageDemandSideLike | null | undefined): string {
  if (!side) return '—';
  const source = side.source?.trim() || '—';
  const confidence = side.confidence?.trim() || '—';
  return `${source} · ${confidence}`;
}

export function formatPageDemandSplitReasons(reasons: string[] | null | undefined): string {
  if (!reasons?.length) return 'None';
  return reasons.join(' · ');
}
